import type { IconName } from 'atoms/Icon'

// Action icon mapping for message actions
export const ACTION_ICON_MAPPING: Record<string, IconName> = {
  call_transport_augment: 'download',
  change_transaction_type: 'edit',
  download_files: 'download',
  extract_x12_meta_data: 'info',
  ignore_and_set_message_as_delivered: 'check',
  move_to_dead: 'skull',
  replay: 'retry',
  revert_first_step: 'arrow-corner-up',
  revert_and_replay: 'retry',
  revert_specific_step: 'arrow-corner-up',
  revert_specific_and_replay: 'retry',
  mark_delivered: 'check',
  skip_aggregation: 'dots-horizontal',
  skip_validation: 'warning',
}

// Message status color mapping
export const MESSAGE_STATUS_COLORS: Record<string, string> = {
  processed: '#33CC60',
  failed: '#f44336',
  processing: '#2196f3',
  ignored: '#ff9800',
  created: '#9e9e9e',
  archived: '#795548',
}

// Message status labels
export const MESSAGE_STATUS_LABELS: Record<string, string> = {
  processed: 'Processed',
  failed: 'Failed',
  processing: 'Processing',
  ignored: 'Ignored',
  created: 'Created',
  archived: 'Archived',
}

// Helper function to get status color with fallback
export const getMessageStatusColor = (status: string, fallback = '#9e9e9e'): string => {
  return MESSAGE_STATUS_COLORS[status] || fallback
}

// Helper function to get status label with fallback
export const getMessageStatusLabel = (status: string): string => {
  return MESSAGE_STATUS_LABELS[status] || status
}

// Re-export z-index constants for convenience
export { Z_INDEX, Z_INDEX_UTILS, Z_INDEX_PATTERNS } from './constants/zIndex'
